import { render } from "./Error.vue?vue&type=template&id=66e013c2&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=66e013c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e013c2"]])

export default __exports__